export const FETCH_FLOW_APPLICANT_DETAIL_INIT = 'FETCH_FLOW_APPLICANT_DETAIL_INIT';
export const FETCH_FLOW_APPLICANT_DETAIL_SUCCESS = 'FETCH_FLOW_APPLICANT_DETAIL_SUCCESS';
export const FETCH_FLOW_APPLICANT_DETAIL_FAILURE = 'FETCH_FLOW_APPLICANT_DETAIL_FAILURE';

export const BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_INIT = 'BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_INIT';
export const BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_SUCCESS = 'BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_SUCCESS';
export const BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_FAILURE = 'BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_FAILURE';

export const FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_INIT = 'FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_INIT';
export const FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_SUCCESS = 'FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_SUCCESS';
export const FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_FAILURE = 'FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_FAILURE';
export const FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_RESET = 'FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_RESET';

export const FLOW_APPLICANT_DETAIL_CREATE_FLOW_INIT = 'FLOW_APPLICANT_DETAIL_CREATE_FLOW_INIT';
export const FLOW_APPLICANT_DETAIL_CREATE_FLOW_SUCCESS = 'FLOW_APPLICANT_DETAIL_CREATE_FLOW_SUCCESS';
export const FLOW_APPLICANT_DETAIL_CREATE_FLOW_FAILURE = 'FLOW_APPLICANT_DETAIL_CREATE_FLOW_FAILURE';
export const FLOW_APPLICANT_DETAIL_CREATE_FLOW_RESET = 'FLOW_APPLICANT_DETAIL_CREATE_FLOW_RESET';

export const FLOW_APPLICANT_DETAIL_UPDATE_FLOW_INIT = 'FLOW_APPLICANT_DETAIL_UPDATE_FLOW_INIT';
export const FLOW_APPLICANT_DETAIL_UPDATE_FLOW_SUCCESS = 'FLOW_APPLICANT_DETAIL_UPDATE_FLOW_SUCCESS';
export const FLOW_APPLICANT_DETAIL_UPDATE_FLOW_FAILURE = 'FLOW_APPLICANT_DETAIL_UPDATE_FLOW_FAILURE';
export const FLOW_APPLICANT_DETAIL_UPDATE_FLOW_RESET = 'FLOW_APPLICANT_DETAIL_UPDATE_FLOW_RESET';

export const FLOW_APPLICANT_DETAIL_TOOGLE_TO_SEND = 'FLOW_APPLICANT_DETAIL_TOOGLE_TO_SEND';

export const FLOW_APPLICANT_DETAIL_SEND_FLOWS_INIT = 'FLOW_APPLICANT_DETAIL_SEND_FLOWS_INIT';
export const FLOW_APPLICANT_DETAIL_SEND_FLOWS_SUCCESS = 'FLOW_APPLICANT_DETAIL_SEND_FLOWS_SUCCESS';
export const FLOW_APPLICANT_DETAIL_SEND_FLOWS_FAILURE = 'FLOW_APPLICANT_DETAIL_SEND_FLOWS_FAILURE';

export const FLOW_APPLICANT_DETAIL_RESET = 'FLOW_APPLICANT_DETAIL_RESET';



// WEBPACK FOOTER //
// ./source/client/actions/flow_applicant_detail/types.js